/**
 * Routing for verification requests actions.
 */
if (window.location.href.includes('/membership')) {
  import('./advertise');
} else if (window.location.href.includes('/verification_requests/new_v2_a')) {
  import('./new_verification_request_v2_a');
} else if (window.location.href.includes('/verification_requests/new_v2_b')) {
  import('./new_verification_request_v2_b');
} else if (window.location.href.includes('/verification_requests/new_v2_c')) {
  import('./new_verification_request_v2_c');
} else if (window.location.href.includes('/verification_requests/new_v2_d')) {
  import('./new_verification_request_v2_d');
} else if (window.location.href.includes('/verification_requests/new_from_banner')) {
  import('./new_verification_request_from_banner');
} else if (window.location.href.includes('/verification_requests/new')) {
  import('./new_verification_request');
}
